import { LoginHeader } from 'components/Header/LoginHeader/LoginHeader';
import React, { FC } from 'react';

export const Header: FC = () => <LoginHeader />;
